import React from "react";
import "./boqInfo.css";
import MultipleSelection from "./MultipleSelection";
import { useSelector } from "react-redux";
import SingleSelectionNew from "./SingleSelectionNew";

export default function BOQInfo() {
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData[roofIndex];

  return (
    <>
      {quantityInfo.allRoof ? (
        roofData.map((item, index) => (
          <React.Fragment key={index}>
            <div className="boqInfoContainer" style={{ marginTop: "30px" }}>
              <h3>Roof {index + 1}</h3>
              {item.mountingStructure !== "Customized Structure" ? (
                <>
                  <ul className="boqTableHead">
                    <li>SERIAL NO.</li>
                    <li>IMAGE</li>
                    <li>DESCRIPTION</li>
                    <li>QUANTITY </li>
                  </ul>
                  {item.structureType === "Single" ? (
                    <SingleSelectionNew roofDetail={item}></SingleSelectionNew>
                  ) : (
                    <MultipleSelection roofDetail={item}></MultipleSelection>
                  )}
                </>
              ) : (
                <h5
                  style={{
                    fontSize: "13px",
                  }}
                >
                  Due to customized structure no calculation shows
                </h5>
              )}
            </div>
          </React.Fragment>
        ))
      ) : (
        <div className="boqInfoContainer" style={{ marginTop: "30px" }}>
          <ul className="boqTableHead">
            <li>SERIAL NO.</li>
            <li>IMAGE</li>
            <li>DESCRIPTION</li>
            <li>QUANTITY</li>
          </ul>
          {roofDetail.structureType === "Single" ? (
            <SingleSelectionNew roofDetail={roofDetail} />
          ) : (
            <MultipleSelection roofDetail={roofDetail}></MultipleSelection>
          )}
        </div>
      )}
    </>
  );
}
